import Notify, { genericErrorMessage } from '@/utils/app-notification';
import { get } from 'lodash-es';

interface ApiRequestOptions {
  successMessage?: string | undefined;
  errorCallback?: (err: unknown) => void;
}

export async function apiRequestHandler<T>(
  execFunc: () => Promise<T>,
  options?: ApiRequestOptions
) {
  try {
    const response = await execFunc();
    if (options?.successMessage) {
      Notify({
        type: 'success',
        message: options.successMessage,
      });
    }
    return response;
  } catch (e: unknown) {
    if (options?.errorCallback) options.errorCallback(e);
    if (import.meta.env.MODE === 'development') {
      console.error(e);
    }
    const statusCode = get(e, 'status');
    if (statusCode === 500 || statusCode === 404) {
      Notify({
        type: 'error',
        message: genericErrorMessage,
      });
    } else {
      Notify({
        type: 'error',
        message: get(e, 'message') || genericErrorMessage,
      });
    }
  }
}
